import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Typography, Button } from '@mui/material'
import loadComponent from 'src/utils/loadMFE'
import { CompanyBranch } from 'types/orga'
import { useNavigate } from 'react-router-dom'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'

const CompanyBranchList = React.lazy(() => loadComponent('orga', 'CompanyBranchList'))

const StyledContainer = styled(RouteContainer)`
    flex: 1;
`

const StyledHeading = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export function CompanyBranchIndexRoute() {
    const navigate = useNavigate()
    const { company, openFlightDeck } = useFlightDeck()

    const onSelect = useCallback(
        (companyBranch: CompanyBranch) => {
            navigate(companyBranch._id)
        },
        [navigate],
    )

    return (
        <StyledContainer>
            <StyledHeading variant="h4">Filialen</StyledHeading>
            {!company ? (
                <>
                    <GenericNotice
                        title="Keine Firma ausgewählt"
                        message="Filialen gehören immer zu einer Firma. Bitte wähle eine Firma im Flight Deck aus, um dessen Filialen zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <CompanyBranchList companyId={company?._id} onSelect={onSelect} />
            )}
        </StyledContainer>
    )
}
